import React, { useState, useMemo } from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'

import { Cross } from '../components/UI/Cross'
import { PopupBox } from '../components/popups/PopupBox'
import { colors } from '../styles/colors'
import { PrimaryButton } from '../components/UI/PrimaryButton'
import { useFirebase } from 'react-redux-firebase'
import { fire_storage } from '../store'
import { PhotoInput } from '../components/UI/PhotoInput'
import { Loading } from '../components/UI/Loading'
import { processNewPhoto } from '../functions/processNewPhoto'

const Container = styled.div`
    width: 100%;
    height: 100%;
    overflow: auto;

    position: fixed;
    top: 0:
    left: 0;
    z-index: 10;
    background: rgba(255, 255, 255, 0.5);

    padding: 2rem;

    // INCLUDED CLASSES:

    .popup-box {
        margin: 5rem auto;
    }
    .title {
        max-width: 500px;
        font-family: 'SF UI Text',sans-serif;
        font-weight: 400;
        font-size: 3.75rem;
        line-height: 160%;
        color: ${colors.white};
        margin-bottom: 3.75rem;
    }

    .input-description, p {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        font-size: 2rem;
        line-height: 160%;
        color: ${colors.white};
        margin-bottom: 1rem;
    }

    .input {
        width: 100%;
        height: 55px;
        color: ${colors.dark_blue};

        padding-left: 2.5rem; 

        font-family: 'SF UI Text', sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 150%;

        outline: none;

        :not(:last-child) {
            margin-bottom: 3.75rem;
        }

        ::placeholder {
            font-family: 'SF UI Text',sans-serif;
            font-weight: 300;
            font-size: 2.5rem;
            line-height: 150%;    
            color: ${colors.dark_blue};
        }

        @media (max-width: 767.98px) {
            flex-direction: column;
            margin-bottom: 3.75rem;

        }
    }

    input[type='number'] {
        ::-webkit-inner-spin-button,
        ::-webkit-outer-spin-button {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            margin: 0;
        }
    }

    .submit-button {
        width: 200px;
        margin: 3rem auto 0 auto;
    }

    .textarea {
        width: 100%;
        min-height: 200px;
        margin-bottom: 3.75rem;
        outline: none;
        padding: 2.5rem;

        font-family: 'SF UI Text',sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 150%;

        color: ${colors.dark_blue};

        ::placeholder {
            font-family: 'SF UI Text',sans-serif;
            font-weight: 300;
            font-size: 2.5rem;
            line-height: 150%;    
            color: ${colors.dark_blue};
        }

        @media (max-width: 767.98px) {
            flex-direction: column;
            margin: 0;
        }

    }
    .photo-inputs {
        display: flex;
        justify-content: space-evenly;
        margin: 2rem 0 6rem 0;
    }
    .photo-input {
        display: flex;
        flex-direction: column;
        align-items: center;

        .cross-button {
            margin-top: 2rem;
            transform: translateX(-50%);

            svg {
                width: 2rem;
                height: 2rem;
            }
        }
        input {
            display: none;
        }
    }

    .success-alert {
        padding: 5rem 0;
        p {
            max-width: 100%;
            text-align: center;
        }
        .submit-button {
            margin-top: 5rem;
        }
    }
    .preloader {
        margin-top: 3rem;
        display: flex;
        justify-content: center;
    }
`

const Success = ({ onclick }) => {
    return (
        <div className='success-alert'>
            <p className="title">Товар успешно добавлен!</p>
            <p>Добавить еще один?</p>
            <PrimaryButton className='submit-button' lighten onClick={() => onclick(false)} >Добавить ещё</PrimaryButton>
        </div>
    )
}

export const AddNewProduct = () => {

    const firebase = useFirebase()
    const database = firebase.ref('products/products_list')

    const dispatch = useDispatch()

    const [successOpened, setSuccessOpened] = useState(false)
    const [loading, setLoading] = useState(false)


    const [productPicture, setProductPicture] = useState('')
    const [productPicture1, setProductPicture1] = useState('')
    const [productPicture2, setProductPicture2] = useState('')

    const firstPicture = useMemo(() => <PhotoInput picture={productPicture} setPicture={setProductPicture} />, [productPicture])
    const secondtPicture = useMemo(() => <PhotoInput picture={productPicture1} setPicture={setProductPicture1} />, [productPicture1])
    const thirdPicture = useMemo(() => <PhotoInput picture={productPicture2} setPicture={setProductPicture2} />, [productPicture2])

    const category = useSelector(state => state.add_product.category)
    const [productName, setProductName] = useState('')
    const [price, setPrice] = useState('')
    const [description, setDescription] = useState('')
    const [techProps, setTechProps] = useState('')

    function handleSubmit() {
        const formated_product_name = productName.toLowerCase().trim().replace(/\s{2,}/g, ' ')
        // eslint-disable-next-line
        const product_has_photos = productPicture != false || productPicture1 != false || productPicture2 != false

        if (formated_product_name) {
            const pictures = [productPicture, productPicture1, productPicture2]
            const exist_pictures = pictures.filter(e => e ? true : false)

            function pushDataToDatabase(pictures_data) {
                const product_data = {
                    pictures: pictures_data,
                    category,
                    product_name: formated_product_name,
                    price,
                    description,
                    tech_props: techProps,
                }
                database.push(product_data)
                console.log(product_data);

                setProductPicture('')
                setProductPicture1('')
                setProductPicture2('')

                setProductName('')
                setPrice('')
                setDescription('')
                setTechProps('')

                setSuccessOpened(true)
            }

            if (product_has_photos) {
                const ref = fire_storage.ref(`img/products/`)

                async function processPhotos(length) {
                    setLoading(true)

                    try {                      
                        switch (length) {
                            case 1:
                                {   
                                    const picture_data = await processNewPhoto( ref, exist_pictures[0])
                                    const product_pictures_data = [picture_data]
                                    pushDataToDatabase(product_pictures_data)
                                }
                                break;
                            case 2:
                                {
                                    const picture_data = await processNewPhoto(ref, exist_pictures[0])
                                    const picture_data1 = await processNewPhoto(ref, exist_pictures[1])
    
                                    const product_pictures_data = [ picture_data, picture_data1 ]
                                    pushDataToDatabase(product_pictures_data)
                                }
                                break;
                            case 3:
                                {
                                    const picture_data = await processNewPhoto(ref, exist_pictures[0])
                                    const picture_data1 = await processNewPhoto(ref, exist_pictures[1])
                                    const picture_data2 = await processNewPhoto(ref, exist_pictures[2])
    
                                    const product_pictures_data = [ picture_data, picture_data1, picture_data2 ]
                                    pushDataToDatabase(product_pictures_data)
                                }
                                break;
    
                            default:
                                break;
                        }
                    } catch { 
                        return
                    } finally {
                        setLoading(false)
                    }
                    
                }
                processPhotos(exist_pictures.length)

            } else {
                console.log('No pictures');
                const updated_pictures = ['']
                pushDataToDatabase(updated_pictures)
            }

        } else {
            alert('Пожалуйста, заполните поле "Наименование товара"')
            return
        }

    }

    return (
        <Container>
            <PopupBox className='popup-box'>
                <div onClick={() => dispatch({ type: 'ADD_NEW_PRODUCT_CLOSED' })}> <Cross lighten /> </div>

                {successOpened
                    ? <Success onclick={setSuccessOpened} />
                    : <>
                        <p className="title">Добавить продукт</p>

                        <div className="inputs">

                            <p className='input-description'>Фото товара</p>
                            <div className="photo-inputs">
                                {firstPicture}
                                {secondtPicture}
                                {thirdPicture}
                            </div>

                            <p className='input-description'>Наименование товара *</p>
                            <input className='input' placeholder='Наименование товара *' type="text" value={productName} onChange={(e) => setProductName(e.target.value)} required />

                            <p className='input-description'>Введите цену в рублях без копеек (например: 7600) <br /> или оставьте поле пустым (если цена по запросу)</p>
                            <input className='input' type="number" placeholder='Цена, р' value={price} onChange={(e) => setPrice(e.target.value)} />

                            <p className='input-description'>Описание товара</p>
                            <textarea className='textarea' placeholder='Описание товара' value={description} onChange={(e) => setDescription(e.target.value)} ></textarea>

                            <p className='input-description'>Технические характеристики</p>
                            <textarea className='textarea' placeholder='Технические характеристики' value={techProps} onChange={(e) => setTechProps(e.target.value)} ></textarea>

                        </div>
                        <p>* - обязательные поля</p>  <hr /> <br />
                        <p>В полях "Описание ... " и "Технические ... " используйте: <br />
                            {`<br/>`} - для принудительного перехода на новую строку; <br />
                            {`<b> ваш текст </b>`} - выделяет текст жирным цветом; <br />
                            {`<i> ваш текст </i>`} - задает стиль текста - курсив; <br /><br />
                            Это не влияет на текст внутри поля, но вносит изменения при выводе информации в блоке товара.
                        </p>

                        {loading
                            ? <Loading lighten />
                            : <PrimaryButton lighten className='submit-button' onClick={() => handleSubmit()}>Добавить</PrimaryButton>
                        }
                    </>
                }
            </PopupBox>
        </Container>
    )
}

